import React from 'react';
import "./styles.css";

// icons needed 
import FacebookIcon from '../../icons/facebook.svg'
import TwitterIcon from '../../icons/tweeter.svg'
import InstagramIcon from '../../icons/instagram.svg'
import LinkedinIcon from '../../icons/linkedin.svg'

function ShareIcon({
  iconName,
  url,
  postText,
  dark
}) {

  return (
    <div className={"w-10 h-10 rounded-full p-2 bg-gray-100 " + (dark && " icon-container-darkbg")}>
      {iconName === "twitter" &&
        <a
          href={`https://twitter.com/intent/tweet?text=${postText}&&url=${url}`}
          target="_blank"
          rel="noreferrer"
        >
          <img
            className="icon"
            src={TwitterIcon}
            alt="twitter"
          /></a>
      }
      {iconName === "facebook" &&
        <a
          href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
          target="_blank"
          rel="noreferrer"
        >
          <img
            className="icon"
            src={FacebookIcon}
            alt="facebook"
          />
        </a>
      }
      {iconName === "instagram" &&
        <img
          className="icon"
          src={InstagramIcon}
          alt="instagram"
        />
      }
      {iconName === "linkedin" &&
        <a
          href={`http://www.linkedin.com/shareArticle?mini=true&url=${url}`}
          target="_blank"
          rel="noreferrer"
        >
          <img
            className="icon"
            src={LinkedinIcon}
            alt="linkedin"
          />
        </a>
      }
    </div>
  )
}

export default ShareIcon
